import * as React from "react";
const SvgFiRrArrowsHCopy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrows-h-copy_svg__a)">
      <path
        fill="#062147"
        d="m16.332 18.253-2.885 2.835c-.108.108-.255.245-.414.389V2.522c.16.146.308.283.42.4l2.879 2.828a1 1 0 1 0 1.4-1.426L14.861 1.5c-.2-.2-.513-.486-.84-.776a3 3 0 0 0-3.976 0c-.327.289-.637.573-.834.77L6.332 4.319a1 1 0 0 0 1.4 1.426l2.885-2.834c.108-.108.255-.244.414-.389v18.955a9 9 0 0 1-.42-.4l-2.877-2.824a1 1 0 0 0-1.4 1.427l2.871 2.82c.2.2.513.487.84.777a3 3 0 0 0 1.982.752h.012c.73 0 1.436-.269 1.983-.754.326-.289.636-.572.833-.769l2.879-2.828a1 1 0 0 0-1.4-1.427z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrows-h-copy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowsHCopy;
